import { ChangeDetectorRef, inject, Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '../services/locale.service';
import { SolText } from '../models/core/sol-text';

@Pipe({
  name: 'translate',
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private localeService = inject(LocaleService);
  private cdr = inject(ChangeDetectorRef);

  constructor() {
    this.localeService.watchComputed(
      state => state.translations,
      () => {
        this.cdr.markForCheck();
      },
    );
  }

  /**
   * Translate pipe can be used to translate a key with optional parameters. Examples:
   * ```html
   * {{ 'hello-key' | translate }}
   * {{ 'hello-name-key' | translate: { name: 'Jane' } }}
   * ```
   * The json file should contain the keys and corresponding templates:
   * ```json
   * {
   *   "hello-key": "Hello",
   *   "hello-name-key": "Hello {{name}}"
   * }
   * ```
   */
  transform(key: string | SolText | undefined, params: Record<string, any> = {}): string {
    if (key instanceof SolText) {
      return this.localeService.translateText(key);
    }
    return this.localeService.translate(key, params);
  }
}
